<template>
  <div class="approval">
    <!-- 集团 -->
    <el-tabs v-model="activeName">
      <el-tab-pane
        v-for="item in tabs"
        :key="item.code"
        :label="item.name"
        :name="item.code"
      >
        <approval-config
          v-if="activeName === item.code"
          :groupType="item.code"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// 获取 审批流名称
// eslint-disable-next-line import/no-cycle
import { getGroupTypeList } from '@/api/domain/approvals'
// 组件
import approvalConfig from '../../components/approvalConfig/index'

export default {
  components: {
    approvalConfig,
  },
  data() {
    return {
      activeName: '',
      tabs: [],
    }
  },
  methods: {
    async getGroupTypeList() {
      const { code, data = [] } = await getGroupTypeList()
      if (code === 1) {
        this.tabs = data.map(({ groupType, groupName }) => ({
          code: `${groupType}`,
          name: `${groupName}`,
        }))
        this.activeName = `${data?.[0]?.groupType || ''}`
      }
    },
  },
  created() {
    this.getGroupTypeList()
  },
}
</script>
